import React from 'react';
import { Check as CheckIcon } from 'lucide-react';
const painPoints = ["I sleep 7 or 8 hours and still wake up exhausted — and I don't understand why", "I eat well and still gain weight. It feels like my body doesn't listen to me anymore", 'I have belly fat I never had before — and nothing seems to move it', 'I get bloated after eating even when I choose something healthy', 'I have sugar cravings in the afternoon that I never used to have — and they always win', "I want to take care of myself but I don't have the energy or mental space for complicated recipes", "Nobody explains why I feel this way — and I'm exhausted from not understanding my own body"];
export function PainPoints() {
  return <section className="bg-sand py-20 sm:py-24" data-id="element-138">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-139">
        <div className="max-w-2xl" data-id="element-140">
          <p className="eyebrow" data-id="element-141">Does this sound like you?</p>
          <h2 className="section-title mt-3" data-id="element-142">
            You&apos;re not imagining it — your body is asking for a different
            kind of morning.
          </h2>
          <p className="mt-5 text-lg leading-8 text-forest/75" data-id="element-143">
            If you&apos;ve been nodding along to any of these, you&apos;re in
            the right place.
          </p>
        </div>

        <div className="mt-10 grid gap-7 lg:grid-cols-[1.08fr_.92fr] lg:items-start lg:gap-10" data-id="element-144">
          <ul className="grid content-start gap-3" aria-label="Common menopause frustrations" data-id="element-145">
            {painPoints.map(point => <li key={point} className="flex min-h-[5.35rem] items-start gap-4 rounded-xl bg-white px-5 py-4 text-[15px] leading-6 text-forest shadow-sm" data-id="element-146">
                <CheckIcon size={19} className="mt-0.5 shrink-0 text-terracotta" aria-hidden="true" data-id="element-147" />
                <span data-id="element-148">{point}</span>
              </li>)}
          </ul>

          <figure className="overflow-hidden rounded-2xl border border-forest/10 bg-cream p-2 shadow-lg shadow-forest/10" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/8morGjpgJNNbZ9Ky3h3k3H/Desayunos_4.jpg" alt="Fried eggs with avocado, berries, and seeded yogurt on a white plate" className="aspect-[4/5] w-full rounded-xl object-cover object-center lg:aspect-[4/5]" data-id="element-150" />
            <figcaption className="px-4 pb-2 pt-4 text-center text-sm font-semibold leading-6 text-forest/80" data-id="element-151">
              A satisfying breakfast can feel simple, bright, and supportive.
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}